<div class="tabla-control-container">
  <div class="tabla-header">
    <h3><i class="fas fa-table"></i> Control de Estudiantes</h3>
    <div class="tabla-stats" *ngIf="estudiantes && estudiantes.length > 0">
      <span class="stat-item">
        <i class="fas fa-users"></i> Total: {{ estudiantes.length }}
      </span>
      <span class="stat-item status-success">
        <i class="fas fa-check-circle"></i> Completos: {{ getEstudiantesPorEstado('success').length }}
      </span>
      <span class="stat-item status-warning">
        <i class="fas fa-exclamation-triangle"></i> Con advertencias: {{ getEstudiantesPorEstado('warning').length }}
      </span>
      <span class="stat-item status-error">
        <i class="fas fa-times-circle"></i> Con errores: {{ getEstudiantesPorEstado('error').length }}
      </span>
      <span class="stat-item status-pending">
        <i class="fas fa-clock"></i> Pendientes: {{ getEstudiantesPorEstado('pending').length }}
      </span>
    </div>
  </div>

  <!-- Grouping controls -->
  <div class="grouping-controls" *ngIf="estudiantes && estudiantes.length > 0">
    <div class="control-group">
      <label for="groupBy">Agrupar por:</label>
      <select id="groupBy" [(ngModel)]="groupBy" (change)="onGroupByChange()">
        <option value="none">Sin agrupar</option>
        <option value="instructor">Instructor</option>
        <option value="graduation">Cinturón (Examen)</option>
      </select>
    </div>
  </div>

  <div class="tabla-content" *ngIf="estudiantes && estudiantes.length > 0">
    
    <!-- Ungrouped table -->
    <div class="table-responsive" *ngIf="groupBy === 'none'">
      <table class="control-table">
        <ng-container *ngTemplateOutlet="tableHeaderTemplate; context: { grouped: false }"></ng-container>
        <tbody>
          <ng-container *ngFor="let estudiante of estudiantes; trackBy: trackByNroLibreta">
            <ng-container *ngTemplateOutlet="tableRowTemplate; context: { estudiante: estudiante, grouped: false }"></ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>

    <!-- Grouped display -->
    <div class="grouped-tables" *ngIf="groupBy !== 'none' && groupedStudents.length > 0">
      <div class="group-section" 
          *ngFor="let group of groupedStudents; trackBy: trackByGroup">
        
        <!-- Group header with click event -->
        <div class="group-header" (click)="toggleGroup(group.groupKey)">
          <!-- Instructor group header -->
          <div class="group-info" *ngIf="groupBy === 'instructor'">
            <i class="fas fa-chevron-down group-toggle-icon" 
              [class.rotated]="isGroupCollapsed(group.groupKey)"></i>
            
            <!-- Instructor info with badge and details -->
            <div class="instructor-group-header">
              <div class="instructor-badge">
                <i class="fas fa-user-tie"></i>
                <span class="instructor-id">{{ group.instructorData?.nroLibreta || group.groupKey }}</span>
              </div>
              
              <div class="instructor-details">
                <h4 class="group-title">
                  {{ group.instructorData?.nombre }} {{ group.instructorData?.apellido }}
                  <span *ngIf="group.instructorData && !group.instructorData.activo"> - INACTIVO</span>
                </h4>
                <div class="instructor-stats">
                  <span class="group-count">{{ group.count }} estudiante{{ group.count !== 1 ? 's' : '' }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Graduation group header (unchanged) -->
          <div class="group-info" *ngIf="groupBy === 'graduation'">
            <i class="fas fa-chevron-down group-toggle-icon" 
              [class.rotated]="isGroupCollapsed(group.groupKey)"></i>
              <!-- Belt info with graphic and description -->
            <div class="graduacion-group-header">
              <div class="graduacion-belt">
                <app-cinturon-graphics [graduacion]="group.graduacionData!"
                  size="large">
                </app-cinturon-graphics>
              </div>
              <div class="graduacion-details">
                <h4 class="group-title">
                  {{ group.graduacionData?.descripcion || 'BLANCO' }}
                </h4>
                <span class="group-count">{{ group.count }} estudiante{{ group.count !== 1 ? 's' : '' }}</span>
              </div>
          </div>
        </div>

        <!-- Group table - collapsible -->
        <div class="group-content" [class.collapsed]="isGroupCollapsed(group.groupKey)">
          <div class="table-responsive">
            <table class="control-table grouped-table">
              <ng-container *ngTemplateOutlet="tableHeaderTemplate; context: { grouped: true }"></ng-container>
              <tbody>
                <ng-container *ngFor="let estudiante of group.students; trackBy: trackByNroLibreta">
                  <ng-container *ngTemplateOutlet="tableRowTemplate; context: { estudiante: estudiante, grouped: true }"></ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Payment Summary Section - ALWAYS VISIBLE for instructor groups -->
        <div class="group-payment-summary-container" *ngIf="groupBy === 'instructor'">
          <!-- Payment summary header with its own toggle -->
          <div class="payment-summary-header" (click)="togglePaymentSummary(group.groupKey)">
            <div class="payment-header-content">
              <div class="payment-header-left">
                <i class="fas fa-calculator"></i>
                <span>Caja - {{ group.groupName }}</span>
              </div>
              <div class="payment-header-right">
                <!-- Compact summary when collapsed -->
                <span class="payment-compact-summary" *ngIf="isPaymentSummaryCollapsed(group.groupKey)">
                  {{ getCompactPaymentSummary(group) }}
                </span>
                <i class="fas fa-chevron-down payment-toggle-icon" 
                  [class.rotated]="isPaymentSummaryCollapsed(group.groupKey)"></i>
              </div>
            </div>
          </div>
          
          <!-- Payment summary content - collapsible -->
          <div class="payment-summary-content" [class.collapsed]="isPaymentSummaryCollapsed(group.groupKey)">
            <div class="payment-stat-row">
              <div class="payment-stat">
                <span class="payment-label">Exámenes:</span>
                <span class="payment-value">${{ getGroupExamTotal(group) | number }}</span>
                <span class="payment-count">({{ getGroupExamCount(group) }})</span>
              </div>
              
              <div class="payment-stat">
                <span class="payment-label">Libretas:</span>
                <span class="payment-value">${{ getGroupLibretaTotal(group) | number }}</span>
                <span class="payment-count">({{ getGroupLibretaCount(group) }})</span>
              </div>
              
              <div class="payment-stat">
                <span class="payment-label">Maderas:</span>
                <span class="payment-value">${{ getGroupMaderasTotal(group) | number }}</span>
                <span class="payment-count">({{ getGroupMaderasCount(group) }})</span>
              </div>
              
              <div class="payment-stat">
                <span class="payment-label">Indumentaria:</span>
                <span class="payment-value">${{ getGroupIndumentariaTotal(group) | number }}</span>
              </div>
              
              <div class="payment-stat total">
                <span class="payment-label">Total:</span>
                <span class="payment-value">${{ getGroupPaymentTotal(group) | number }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Empty state -->
  <div class="empty-state" *ngIf="!estudiantes || estudiantes.length === 0">
    <div class="empty-content">
      <i class="fas fa-users"></i>
      <h4>No hay estudiantes registrados</h4>
      <p>Los estudiantes registrados en recepción aparecerán aquí.</p>
    </div>
  </div>
</div>

<!-- Shared Table Header Template -->
<ng-template #tableHeaderTemplate let-grouped="grouped">
  <thead>
    <tr>
      <th class="col-libreta">Nro. Libreta</th>
      <th class="col-database">Base de datos</th>
      <th class="col-nombre">Estudiante</th>
      <th class="col-instructor" *ngIf="!grouped || groupBy !== 'instructor'">Instructor</th>
      <th class="col-graduacion">Grad. Actual</th>
      <th class="col-graduacion" *ngIf="!grouped || groupBy !== 'graduation'">Grad. Examen</th>
      <th class="col-hora">Hora Registro</th>
      <th class="col-pago">
        <i class="fas fa-cash-register"></i> Caja
      </th>
      <th class="col-control">
        <i class="fas fa-exclamation-triangle"></i> Control
      </th>
      <th class="col-detalle">
        <i class="fas fa-tasks"></i> Detalle
      </th>
      <th class="col-acciones">Acciones</th>
    </tr>
  </thead>
</ng-template>

<!-- Shared Table Row Template -->
<ng-template #tableRowTemplate let-estudiante="estudiante" let-grouped="grouped">
    <tr [class]="getRowClass(estudiante)">
    
    <!-- Nro. Libreta -->
    <td class="col-libreta">
      <span class="libreta-number">{{ estudiante.nroLibreta }}</span>
    </td>

    <!-- Base de datos -->
    <td class="col-database">
      <div class="database-buttons">
        <button class="db-btn hakkyo-btn" 
                (click)="onOpenHakkyoDatabase(estudiante)"
                title="Ver en Base de Datos Hakkyo">
          <i class="fas fa-database"></i>
        </button>
        <button class="db-btn itf-btn" 
                (click)="onOpenItfDatabase(estudiante)"
                title="Buscar en ITF Database">
          <i class="fas fa-globe"></i>
        </button>
      </div>
    </td>
    
    <!-- Estudiante (Nombre completo) -->
    <td class="col-nombre">
      <div class="estudiante-info">
        <div class="nombre-completo">
          {{ estudiante.apellido }}, {{ estudiante.nombre }}
        </div>
        <div class="estudiante-status" *ngIf="!estudiante.existeEnBD">
          <small class="text-muted">
            <i class="fas fa-exclamation-triangle"></i> No existe en BD
          </small>
        </div>
      </div>
    </td>
    
    <!-- Instructor (hidden when grouping by instructor) -->
    <td class="col-instructor" *ngIf="!grouped || groupBy !== 'instructor'">
      <div class="instructor-info">
        {{ getInstructorNombre(estudiante.idInstructor, instructores$ | async) }}
      </div>
    </td>
    
    <!-- Graduación Actual with Belt Indicator -->
    <td class="col-graduacion">
      <div class="graduacion-with-belt">
        <app-cinturon-graphics
          [graduacion]="getGraduacionById(estudiante.idGraduacionActual, graduaciones$ | async)"
          size="medium">
        </app-cinturon-graphics>
        <div class="graduacion-text" *ngIf="!getGraduacionById(estudiante.idGraduacionActual, graduaciones$ | async)">
          {{ getGraduacionDescripcion(estudiante.idGraduacionActual, graduaciones$ | async) }}
        </div>
      </div>
    </td>
    
    <!-- Graduación Examen (hidden when grouping by graduation) -->
    <td class="col-graduacion" *ngIf="!grouped || groupBy !== 'graduation'">
      <div class="graduacion-with-belt">
        <app-cinturon-graphics
          [graduacion]="getGraduacionById(estudiante.idGraduacionExamen, graduaciones$ | async)"
          size="medium">
        </app-cinturon-graphics>
        <div class="graduacion-text" *ngIf="!getGraduacionById(estudiante.idGraduacionExamen, graduaciones$ | async)">
          {{ getGraduacionDescripcion(estudiante.idGraduacionExamen, graduaciones$ | async) }}
        </div>
      </div>
    </td>
    
    <!-- Hora Registro -->
    <td class="col-hora">
      <div class="hora-info">
        {{ formatTime(estudiante.horaRegistro) }}
      </div>
    </td>

    <!-- Pago -->
    <td class="col-pago">
      <div class="pago-info">
        <div class="pago-total">
          ${{ estudiante.pago.total | number }}
        </div>
        <div class="pago-status" [class.pagado]="estudiante.pago.pagado" [class.pendiente]="!estudiante.pago.pagado">
          {{ estudiante.pago.pagado ? 'Pagado' : 'Pendiente' }}
        </div>
        <div class="pago-detail">
          <small *ngIf="estudiante.pago.incluyeExamen">Examen</small>
          <small *ngIf="estudiante.pago.incluyeLibreta">Libreta</small>
          <small *ngIf="estudiante.pago.maderasSeleccionadas.length > 0">
            Maderas: {{ getMaderasResumen(estudiante.pago.maderasSeleccionadas) }}
          </small>
          <small *ngIf="estudiante.pago.precioIndumentaria > 0">
            Indumentaria: ${{ estudiante.pago.precioIndumentaria | number }}
          </small>
          <small *ngIf="estudiante.pago.descuentoPorcentaje > 0" class="discount-badge">
            Desc: {{ estudiante.pago.descuentoPorcentaje }}% (-${{ estudiante.pago.descuentoValor | number }})
          </small>
          <small class="medio-pago">{{ estudiante.pago.medioDePago }}</small>
        </div>
      </div>
    </td>
    
    <!-- Control - Status icon, message, warnings -->
    <td class="col-control">
      <div class="control-status">
        <div class="status-icon">
          {{ estudiante.getStatusIcon() }}
        </div>
        <div class="status-message">
          {{ estudiante.getStatusMessage() }}
        </div>
        <!-- Advertencias -->
        <div class="advertencias" *ngIf="estudiante.advertencias && estudiante.advertencias.length > 0">
          <div class="advertencia-item" 
              *ngFor="let advertencia of estudiante.advertencias"
              [title]="advertencia">
            <i class="fas fa-exclamation-triangle"></i>
            <span>{{ advertencia }}</span>
          </div>
        </div>
      </div>
    </td>
    
    <!-- Detalle - Status checks only -->
    <td class="col-detalle">
      <div class="status-details">
        <div class="status-checks">
          <span class="check-item" [class.check-ok]="estudiante.existeEnBD" [class.check-error]="!estudiante.existeEnBD">
            <i class="fas" [ngClass]="estudiante.existeEnBD ? 'fa-check' : 'fa-times'"></i>
            BD
          </span>
          <span class="check-item" [class.check-ok]="estudiante.tomoExamen" [class.check-pending]="!estudiante.tomoExamen">
            <i class="fas" [ngClass]="estudiante.tomoExamen ? 'fa-check' : 'fa-clock'"></i>
            Examen
          </span>
          <span class="check-item" [class.check-ok]="estudiante.datosCoinciden" [class.check-warning]="!estudiante.datosCoinciden && estudiante.existeEnBD">
            <i class="fas" [ngClass]="estudiante.datosCoinciden ? 'fa-check' : 'fa-exclamation-triangle'"></i>
            Datos
          </span>
          <span class="check-item" [class.check-ok]="estudiante.examenesCompletos" [class.check-warning]="!estudiante.examenesCompletos && estudiante.existeEnBD">
            <i class="fas" [ngClass]="estudiante.examenesCompletos ? 'fa-check' : 'fa-exclamation-triangle'"></i>
            Progresión
          </span>
        </div>
      </div>
      <!-- Exámenes faltantes -->
      <div class="examenes-faltantes" *ngIf="estudiante.examenesFaltantes && estudiante.examenesFaltantes.length > 0">
        <small class="text-muted">
          <i class="fas fa-info-circle"></i>
          Faltan: {{ estudiante.examenesFaltantes.join(', ') }}
        </small>
      </div>
    </td>
    
    <!-- Acciones -->
    <td class="col-acciones">
      <div class="acciones-buttons">
        <!-- Edit button -->
        <button class="action-btn edit-btn" 
                (click)="onEditarEstudiante(estudiante)"
                title="Editar estudiante">
          <i class="fas fa-edit"></i>
        </button>
        
        <!-- Observaciones button -->
        <button class="action-btn obs-btn" 
                (click)="openObservaciones(estudiante)"
                title="Agregar observaciones">
          <i class="fas fa-comment"></i>
        </button>
        
        <!-- Delete button -->
        <button class="action-btn delete-btn"
                (click)="onEliminarEstudiante(estudiante.nroLibreta)"
                title="Eliminar estudiante">
          <i class="fas fa-trash"></i>
        </button>
      </div>
    </td>
  </tr>
</ng-template>

<!-- Observaciones Modal -->
<div class="modal-overlay" *ngIf="showObservaciones" (click)="closeObservaciones()">
  <div class="modal-content observaciones-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>
        <i class="fas fa-sticky-note"></i> 
        Observaciones - {{ estudianteObservaciones?.apellido }}, {{ estudianteObservaciones?.nombre }}
      </h4>
      <button class="modal-close" (click)="closeObservaciones()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <div class="observaciones-form">
        <label for="observacionesText">Observaciones:</label>
        <textarea 
          id="observacionesText"
          [(ngModel)]="observacionesText"
          placeholder="Ingrese observaciones sobre el estudiante o la situación..."
          rows="6">
        </textarea>
        <div class="observaciones-info">
          <small class="text-muted">
            <i class="fas fa-info-circle"></i>
            Las observaciones se guardan temporalmente y se incluyen en la exportación.
          </small>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="cancel-btn" (click)="closeObservaciones()">
        <i class="fas fa-times"></i> Cancelar
      </button>
      <button class="save-button" (click)="saveObservaciones()">
        <i class="fas fa-save"></i> Guardar
      </button>
    </div>
  </div>
</div>

<!-- Hakkyo Database Modal -->
<div class="modal-overlay" *ngIf="showHakkyoDetail" (click)="onCloseHakkyoDetail()">
  <div class="modal-content modal-large" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3><i class="fas fa-database"></i> Base de Datos Hakkyo</h3>
      <button class="modal-close" (click)="onCloseHakkyoDetail()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body">
      <app-estudiante-detail
        [estudiante]="selectedEstudianteForDetail"
        [isNew]="isNewEstudiante"
        (cancelEdit)="onCloseHakkyoDetail()"
        (saved)="onEstudianteSaved($event)">
      </app-estudiante-detail>
    </div>
  </div>
</div>

<!-- ITF Database Modal -->
<div class="modal-overlay" *ngIf="showItfDetail" (click)="onCloseItfDetail()">
  <div class="modal-content modal-xlarge" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3><i class="fas fa-globe"></i> ITF Database</h3>
      <button class="modal-close" (click)="onCloseItfDetail()">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="modal-body itf-modal-body">
      <app-itf-database
        [prefilledLibreta]="selectedLibretaForItf">
      </app-itf-database>
    </div>
  </div>
</div>